
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ActionDefinition, Duty } from '../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import DutyStore from '../../../stores/DutyStore';

@Component({
  components: {
    vSelect,
  },
})
export default class DefinitionEditorDutySpecific extends Vue {
  @Prop({ required: true })
  definition!: ActionDefinition;
  @Prop({ required: true })
  parsedJsonParameters!: any;

  readonly dutyStore = new DutyStore();

  public canSaveChanged() {
    this.$nextTick(() => {
      let res = this.dutyId !== null;
      this.$emit("canSaveChanged", res);
    });
  }
  
  get duties(): Duty[] {
    const ret = [...this.dutyStore.duties];
    ret.sort((l, r) => l.title.localeCompare(r.title));
    return ret;
  }

  get dutyId(): number | null {
    return this.parsedJsonParameters.dutyId ?? null;
  }

  set dutyId(value: number | null) {
    this.parsedJsonParameters.dutyId = value;
    this.onParsedJsonChanged();
    this.canSaveChanged();
  }

  mounted() {
    this.dutyStore.loadIfAbsent();
  }

  onParsedJsonChanged() {
    this.$emit('changed', this.parsedJsonParameters);
  }
}
